import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { Egreso } from '@/shared/interfaces';
import { cellNotFilter, formatDateWithTime } from '@/shared';

export const useTableColumnsEgreso = () => {

  const columnaBase = useMemo<MRT_ColumnDef<Egreso>[]>(() => [
    {
      ...cellNotFilter,
      accessorKey: 'fecha',
      header: 'Fecha',
      size: 200,
      Cell: ({ row }) => (
        row.original.fecha != null ?
          formatDateWithTime(row.original.fecha) : '—'
      ),
    },
    {
      ...cellNotFilter,
      accessorKey: "codigo_producto",
      header: "codigo_producto",
      size: 200,
      enableColumnFilter: false,
      enableSorting: false
    },
    {
      ...cellNotFilter,
      accessorKey: "descripcion",
      header: "descripcion",
      size: 400,
      enableColumnFilter: false,
      enableSorting: false
    },
    {
      accessorKey: 'cantidad',
      header: 'cantidad',
      size: 200,
    },
    {
      accessorKey: 'serie',
      header: 'serie',
      size: 200,
    },
    {
      accessorKey: 'precio',
      header: 'precio',
      size: 200,
    },
    {
      accessorKey: 'codigo_egreso',
      header: 'codigo_egreso',
      size: 200,
    },
    {
      ...cellNotFilter,
      accessorKey: 'motivo',
      header: 'MOTIVO EGRESO',
      size: 200
    },
    {
      ...cellNotFilter,
      accessorKey: 'bodega',
      header: 'bodega'
    },
    {
      ...cellNotFilter,
      accessorKey: 'ubicacion',
      header: 'ubicacion'
    },
    {
      accessorKey: 'observaciones',
      header: 'Observaciones',
      size: 200,
    },
    {
      accessorKey: 'usuario',
      header: 'usuario',
      size: 200
    },
  ], [])

  return {
    columnaBase,
  }
};
